'use client'
import { createMapHistoric } from "@/helpers/utils";
import React, { use } from "react";
import { ResultContext } from "../pages/result/result.context";
import "./table-historic-prices.scss";
import TableRow from "./table-row.component";
import ToggleButton from "./toggle-button.component";

export type HistoricOption = { last_price: number; ref_month: string; price_percent_variation: number | null };

export type HistoricProps = {
    historic: {
        fipe: {
            used: HistoricOption[];
            new: HistoricOption[];
        };
        wm_average: {
            armored: HistoricOption[];
            not_armored: HistoricOption[];
        };
    };
};

export default function TableHistoricPrices(historic: HistoricProps) {
    if (!('fipe' in historic.historic) || !('wm_average' in historic.historic)) return

    const { fipe, wm_average } = historic.historic;

    const { isVehicle0km, isVehicleArmored } = use(ResultContext);
    const [tableFullVisible, setTableFullVisible] = React.useState(false);

    const tableData = createMapHistoric(fipe, wm_average, isVehicle0km, isVehicleArmored);

    return (
        <>
            {tableData?.length > 0 && (
                <section className="result-section result-section__table" data-testid="result-section__table" id="result-section__table">
                    <div className="container table-historic-container" data-testid="result-section__table-container" id="result-section__table-container">
                        <div className="table-historic-prices" data-testid="table-historic-prices">
                            <table data-testid="historic-prices-table" className="historic-prices-table">
                                <thead className="table-header" data-testid="historic-prices-table-header">
                                    <tr data-testid="historic-prices-table-header-row" className="table-header-row">
                                        <th data-testid="historic-prices-table-header-ref-month" className="table-header-cell">Mês de referência</th>
                                        <th data-testid="historic-prices-table-header-fipe-price" className="table-header-cell">Preço Fipe</th>
                                        <th data-testid="historic-prices-table-header-fipe-variation" className="table-header-cell">Variação mês anterior (%)</th>
                                        <th data-testid="historic-prices-table-header-wm-price" className="table-header-cell">Preço Webmotors</th>
                                        <th data-testid="historic-prices-table-header-wm-variation" className="table-header-cell">Variação mês anterior (%)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableFullVisible ? tableData?.slice(0, 12)?.map((item: {}, index: number) => (
                                        <TableRow
                                            key={index}
                                            index={index}
                                            item={item}
                                        />
                                    )) : tableData?.slice(0, 6)?.map((item: {}, index: number) => (
                                        <TableRow
                                            key={index}
                                            index={index}
                                            item={item}
                                        />
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        {tableData?.length > 6 &&
                            <ToggleButton
                                isActive={tableFullVisible}
                                onClick={() => setTableFullVisible(!tableFullVisible)}
                            />
                        }
                    </div>
                </section>
            )}
        </>
    );
}
